module.exports = __webpack_public_path__ + "img/footer-top.dd9bf55de9e930d9464c97e08ae7f0d2.svg";